import * as Sentry from "@sentry/browser";
import { BrowserTracing } from "@sentry/tracing";

export const startMonitoring = () => {
    Sentry.init({
    dsn: "https://0f32974e46794503a731b11b50dd3cf8@o4504050525863936.ingest.sentry.io/4504050573377537",
    integrations: [new BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    });
} 